import { axioTokens } from "../theme";

export const TOP_MATCH_LIMIT = 3;
export const TOP_MATCH_STRENGTH_HIGH = 0.7;
export const TOP_MATCH_STRENGTH_MID = 0.4;
export const TOP_MATCH_GRID_COLS = { base: 1, [axioTokens.containerQuery.sm]: 3 } as const;

export const REJECTION_INSIGHT_MIN_FEEDBACKS = 3;

export const JOB_INSIGHT_TYPE_LABELS: Record<string, string> = {
  rejection_pattern: "Rejection patterns",
  success_pattern: "Success patterns",
  hiring_criteria: "Hiring criteria",
  general: "General",
};

export const JOB_INSIGHT_SOURCE_LABELS: Record<string, string> = {
  admin_manual: "Admin",
  ai_admin_triggered: "AI draft",
  ai_auto_triggered: "Auto draft",
};

export const JOB_INSIGHT_TYPE_OPTIONS = [
  { value: "rejection_pattern", label: "Rejection patterns" },
  { value: "success_pattern", label: "Success patterns" },
  { value: "hiring_criteria", label: "Hiring criteria" },
  { value: "general", label: "General" },
];

export const PREP_SECTION_KEYS = [
  "call_checklist",
  "candidate_strengths",
  "red_flags",
] as const;

export const PREP_SECTION_LABELS: Record<(typeof PREP_SECTION_KEYS)[number], string> = {
  call_checklist: "Call checklist",
  candidate_strengths: "Strengths",
  red_flags: "Probe",
};

export const PREP_BRIEFING_LABEL = "Call briefing";
export const PREP_BRIEFING_REQUEST_LABEL = "Get call briefing";
export const PREP_BRIEFING_LOADING = "Writing briefing…";
export const PREP_BRIEFING_ERROR = "Could not load briefing.";
export const PREP_BRIEFING_EMPTY = "No briefing for this match yet.";
export const PREP_BRIEFING_RETRY = "Retry";

export const EXPLORE_CARD_VIEW_EVENT = "explore.card_view";
export const EXPLORE_BRIEFING_REQUEST_EVENT = "explore.briefing_request";

export function interviewPrepQueryKey(candidateId: string, jobId: string) {
  return ["interview-prep", candidateId, jobId] as const;
}

export const ALLOWED_BRIEFING_TAGS = ["UL", "LI", "STRONG", "EM"] as const;